export const limitedWindowAroundCenter = (center, max, windowSize, offset = 0) => {
  // The window is centered around the `center`, but if the window would go out of bounds,
  // it is shifted to stay within bounds but always retains windowSize as its size.
  // It favors the top side of the window when the windowSize is even.
  const windowSizeWithoutCenter = windowSize - 1

  const halfWindow = Math.floor(windowSizeWithoutCenter / 2)
  let from = center + offset - halfWindow
  let to = center + offset + halfWindow + (windowSizeWithoutCenter % 2)

  if (from < 1) {
    to += 1 - from
    from = 1
  }

  if (to > max) {
    from -= to - max
    to = max
  }

  from = Math.max(from, 1)
  to = Math.min(to, max)

  return [from, to]
}
